module.exports = __webpack_public_path__ + "static/img/amg-3.6a39625.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/amg-3.jpg
// module id = jwCB
// module chunks = 1